import { IconAlertTriangleFilled, IconFileText, IconLoader2 } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import { TaskStatusResponse } from 'queries/InvestmentMemo/useTaskStatus';
import useMarkInvestmentMemoViewed from 'queries/InvestmentMemo/useMarkInvestmentMemoViewed';
import { LatestInvestmentMemoResponse } from 'queries/InvestmentMemo/useLatestInvestmentMemo';

interface TaskStatusDisplayProps {
    organizationId: string;
    dealId: number;
    proFormaId: number;
    latestInvestmentMemo?: LatestInvestmentMemoResponse;
    taskStatus: TaskStatusResponse;
}

const TaskStatusDisplay = ({
    organizationId,
    dealId,
    proFormaId,
    latestInvestmentMemo,
    taskStatus,
}: TaskStatusDisplayProps) => {
    const { status } = taskStatus;

    const { mutate: markInvestmentMemoViewed } = useMarkInvestmentMemoViewed({
        organizationId,
        dealId,
        proFormaId,
        investmentMemoId: latestInvestmentMemo?.id ?? 0,
    });

    if (status === 'PENDING' || status === 'PROGRESS') {
        return (
            <div className="d-flex align-items-center justify-content-center mt-2">
                <NSIcon icon={IconLoader2} spin className="mr-2" />
                Generating deck...
            </div>
        );
    }

    if (status === 'SUCCESS' && latestInvestmentMemo?.documentId && !latestInvestmentMemo.viewedAt) {
        return (
            <div className="mt-2">
                <a
                    href={`/deal/${dealId}/documents`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm d-flex text-success align-items-center justify-content-center w-100"
                    onClick={() => {
                        if (latestInvestmentMemo?.id) {
                            markInvestmentMemoViewed();
                        }
                    }}
                >
                    <NSIcon icon={IconFileText} className="mr-2" />
                    View deck in Documents
                </a>
            </div>
        );
    }

    if (status === 'FAILURE') {
        return (
            <div className="d-flex align-items-center justify-content-center mt-2">
                <NSIcon icon={IconAlertTriangleFilled} className="text-danger mr-2" />
                Error generating deck, please try again
            </div>
        );
    }

    return null;
};

export default TaskStatusDisplay;
